module.exports = {"id":"dp1_2l3q2","text":"Evaluating Information","instructions":"Why can AI-generated information sometimes be unreliable?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"1.2","questionType":"PickOne","random":true,"options":[{"id":"dp1_2l3q2-a1","text":"Training data limits","score":3.7},{"id":"dp1_2l3q2-a2","text":"Faster processing","score":1.3},{"id":"dp1_2l3q2-a3","text":"Interface design","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat1.2/l3q2.json
// module id = 950
// module chunks = 41